import { createFileRoute } from '@tanstack/react-router'
import { zodValidator, fallback } from '@tanstack/zod-adapter'
import { z } from 'zod'
import { NvRapporteringListPage } from 'pages/app/naturvardsverket/NvRapporteringListPage/NvRapporteringListPage'
import { getWasteList } from 'api/waste.api'

export const NV_RAPPORTERING_LIST_PAGE_SIZE = 20

const nvRapporteringListSearchSchema = z.object({
  page: fallback(z.number().int().positive(), 1).default(1),
  q: fallback(z.string().optional(), undefined),
})

export const Route = createFileRoute('/_authenticated/app/avfallsregistret/')({
  validateSearch: zodValidator(nvRapporteringListSearchSchema),
  beforeLoad: ({ context: { queryClient }, search }) => {
    const { page = 1, q } = search

    // Fire-and-forget: awaiting here blocks the navigation until the fetch
    // completes, so the page never sees a loading state (search spinner and
    // PageLoader were dead code). Prefetch warms the cache without blocking.
    void queryClient.prefetchQuery(
      getWasteList({
        onlyNv: true,
        limit: NV_RAPPORTERING_LIST_PAGE_SIZE,
        offset: (page - 1) * NV_RAPPORTERING_LIST_PAGE_SIZE,
        searchQuery: q,
      })
    )
  },
  component: NvRapporteringListPage,
})
